<!--PAGE-->
<div class="pageLayout twoScreenPageWrapper">
	<!--HEADER-->
	<header>
		<div class="headerContent">
			<button
				(click)="historyBack()"
				[matTooltip]="T.BUTTON_GO_BACK | translate"
				class="backButton"
				color="accent"
				mat-icon-button
				matTooltipClass="accent"
			>
				<mat-icon fontIcon="fa-arrow-left" fontSet="fad" inline />
			</button>
			<label class="headerLabel mat-headline-4">
				@if (headerIcon()) {
					<mat-icon [fontIcon]="headerIcon()" fontSet="fad" inline />
				}
				{{ headerLabel() | translate }}
			</label>
			<div class="actionWrapper" role="region">
				<ng-content select="[headerActions]" />
				<sim-autosave-widget
					[promise]="autosaveConfig()?.promise"
					[timestamp]="autosaveConfig()?.timestamp"
					[warningMessage]="autosaveConfig()?.warning"
				/>
			</div>
		</div>
		<mat-divider />
	</header>

	<!--BODY-->
	<main>
		<!--LOADING-->
		@if (isLoading() || hasError()) {
			<sim-component-loading-container
				[isLoading]="isLoading()"
				[errorLoading]="!isLoading() && hasError()"
				[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
				[loadingIcon]="'fad ' + headerIcon()"
				[fullWidthLoadingCon]="true"
				[showBackDrop]="true"
				size="big"
			/>
		} @else {
			<ng-content select="[body]" />
		}
	</main>

	<!--ACTIONS-->
	<section class="pageActions">
		@if (!isLoading() && !hasError()) {
			<ng-content select="[actions]" />
		}
	</section>
</div>
